import loadable from '@loadable/component';

export const UnpublishedJobPageLoadable = loadable(
  () => import('./UnpublishedJobPage'),
  { resolveComponent: (module) => module.UnpublishedJobPage },
);
